/**
 * Custom Wishlist - Works with or without login (localStorage + API sync)
 * Injects icons into .custom-wishlist-pd, updates header count via AJAX
 * When logged in, syncs to API for cross-device persistence
 */
(function () {
  const STORAGE_KEY = 'custom_wishlist';
  const WISHLIST_PAGE_URL = '/pages/wishlist';
  const FLITS_CUSTOMER_ID_KEY = 'production_flits_wishlist_web_pixel_token_customer_id';
  const API_SAVE_URL = 'https://honeydew-flamingo-674206.hostingersite.com/api/save-wishlist.php';
  const API_FETCH_URL = 'https://honeydew-flamingo-674206.hostingersite.com/api/get-wishlist.php';

  function getCurrentFlitsCustomerId() {
    try {
      var flitsId = localStorage.getItem(FLITS_CUSTOMER_ID_KEY);
      if (flitsId && flitsId !== '-1') return flitsId;
      if (typeof window.ShopifyCustomerId !== 'undefined' && window.ShopifyCustomerId) return String(window.ShopifyCustomerId);
      return null;
    } catch (e) {
      return null;
    }
  }

  function isLoggedIn() {
    var id = getCurrentFlitsCustomerId();
    return id != null && id !== '' && id !== '-1';
  }

  function fetchWishlistFromApi() {
    var flitsCustomerId = getCurrentFlitsCustomerId();
    if (!flitsCustomerId) return Promise.resolve([]);
    var url = API_FETCH_URL + '?flitsCustomerId=' + encodeURIComponent(flitsCustomerId);
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Fetch failed');
        return res.json();
      })
      .then(function (res) {
        if (res && res.status && res.data && Array.isArray(res.data.items)) return res.data.items;
        if (Array.isArray(res)) return res;
        if (res && Array.isArray(res.items)) return res.items;
        return [];
      });
  }

  function saveWishlistToApi(items) {
    var flitsCustomerId = getCurrentFlitsCustomerId();
    if (!flitsCustomerId) return;
    var data = { flitsCustomerId: flitsCustomerId, items: items };
    fetch(API_SAVE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).catch(function () {});
  }

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.items)) return parsed.items;
      return [];
    } catch (e) {
      return [];
    }
  }

  function getWishlistData() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return { flitsCustomerId: null, items: [] };
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return { flitsCustomerId: null, items: parsed };
      if (parsed && Array.isArray(parsed.items)) return { flitsCustomerId: parsed.flitsCustomerId || null, items: parsed.items };
      return { flitsCustomerId: null, items: [] };
    } catch (e) {
      return { flitsCustomerId: null, items: [] };
    }
  }

  function setWishlist(items, skipApiSync) {
    try {
      var flitsCustomerId = getCurrentFlitsCustomerId();
      var data = { flitsCustomerId: flitsCustomerId, items: items };
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      dispatchWishlistChange();
      if (!skipApiSync && isLoggedIn()) saveWishlistToApi(items);
    } catch (e) {}
  }

  function dispatchWishlistChange() {
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: getWishlist().length } }));
  }

  function isInWishlist(productId) {
    return getWishlist().some(function (p) { return String(p.id) === String(productId); });
  }

  function addToWishlist(item) {
    const list = getWishlist();
    if (list.some(function (p) { return String(p.id) === String(item.id); })) return;
    list.push(item);
    setWishlist(list);
  }

  function removeFromWishlist(productId) {
    setWishlist(getWishlist().filter(function (p) { return String(p.id) !== String(productId); }));
  }

  function renderIcon(el, active) {
    const svg = active
      ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="#dc2626" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>'
      : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" xmlns="http://www.w3.org/2000/svg"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
    return '<button type="button" class="custom-wishlist-btn" aria-label="' + (active ? 'Remove from wishlist' : 'Add to wishlist') + '">' + svg + '</button>';
  }

  function initPdBubbles() {
    document.querySelectorAll('.custom-wishlist-pd').forEach(function (el) {
      if (el.dataset.wishlistInit) return;
      el.dataset.wishlistInit = '1';
      var productId = el.dataset.productId;
      var variantId = el.dataset.variantId || '';
      var handle = el.dataset.productHandle || '';
      var title = (el.dataset.productTitle || '').replace(/"/g, '&quot;');
      var image = el.dataset.productImage || '';
      var price = el.dataset.productPrice || 0;
      var active = isInWishlist(productId);
      el.innerHTML = renderIcon(el, active);
      el.classList.toggle('active', active);

      el.addEventListener('click', function (e) {
        if (!e.target.closest('.custom-wishlist-btn')) return;
        e.preventDefault();
        e.stopPropagation();
        if (isInWishlist(productId)) {
          removeFromWishlist(productId);
          el.innerHTML = renderIcon(el, false);
          el.classList.remove('active');
        } else {
          addToWishlist({ id: productId, variantId: variantId, handle: handle, title: title, image: image, price: price });
          el.innerHTML = renderIcon(el, true);
          el.classList.add('active');
        }
      });
    });
  }

  function updateHeaderCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      if (count > 0) {
        el.textContent = count;
        el.style.display = '';
      } else {
        el.textContent = '';
        el.style.display = 'none';
      }
    });
  }

  function runInit() {
    initPdBubbles();
    updateHeaderCount();
  }

  function startObserver() {
    if (window._wishlistObserver || !document.body) return;
    var observer = new MutationObserver(function (mutations) {
      var needsInit = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.classList && node.classList.contains('custom-wishlist-pd') && !node.dataset.wishlistInit) needsInit = true;
          if (node.querySelector && node.querySelector('.custom-wishlist-pd:not([data-wishlist-init])')) needsInit = true;
        }
      }
      if (needsInit) {
        window._wishlistObserver.disconnect();
        runInit();
        window._wishlistObserver.observe(document.body, { childList: true, subtree: true });
      }
    });
    window._wishlistObserver = observer;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function onReady() {
    if (isLoggedIn()) {
      fetchWishlistFromApi()
        .then(function (items) {
          setWishlist(items, true);
          runInit();
          startObserver();
        })
        .catch(function () {
          runInit();
          startObserver();
        });
    } else {
      runInit();
      startObserver();
    }
  }

  document.addEventListener('DOMContentLoaded', onReady);
  document.addEventListener('wishlist:updated', updateHeaderCount);
  document.addEventListener('wishlist:init-pd', runInit);
  document.addEventListener('shopify:section:load', runInit);

  if (document.readyState !== 'loading') {
    onReady();
  }

  window.CustomWishlist = {
    get: getWishlist,
    getData: getWishlistData,
    add: addToWishlist,
    remove: removeFromWishlist,
    isIn: isInWishlist,
    count: function () { return getWishlist().length; },
    pageUrl: WISHLIST_PAGE_URL,
    init: runInit
  };
})();
